import email from '../assets/email.png';
import mobile from '../assets/mobile.png';
import api from '../assets/api.png';
import cpp from '../assets/cpp.png';
import css from '../assets/css.png';
import figma from '../assets/figma.png';
import flutter from '../assets/flutter.png';
import git from '../assets/git.png';
import graphql from '../assets/graphql.png';
import html from '../assets/html.png';
import javascript from '../assets/javascript.png';
import mu5 from '../assets/mu5.png';
import node from '../assets/node.png';
import python from '../assets/python.png';
import react from '../assets/react.png';
import redux from '../assets/redux.png';
import sass from '../assets/sass.png';
import typescript from '../assets/typescript.png';
import vue from '../assets/vue.png';

import portfolio from '../assets/portfolio.png';
import portfolio01 from '../assets/portfolio01.png'
import portfolio02 from '../assets/portfolio02.png'
import portfolio03 from '../assets/portfolio03.png'
import portfolio04 from '../assets/portfolio04.png'
import portfolio05 from '../assets/portfolio05.png'
import portfolio06 from '../assets/portfolio06.png'
import portfolio07 from '../assets/portfolio07.png'
import portfolio08 from '../assets/portfolio08.png'

import aadilrehman from '../assets/aadilrehman.png';
import aadilrehman01 from '../assets/aadilrehman01.png'
import aadilrehman02 from '../assets/aadilrehman02.png'
import aadilrehman03 from '../assets/aadilrehman03.png'
import aadilrehman04 from '../assets/aadilrehman04.png'
import aadilrehman05 from '../assets/aadilrehman05.png'
import aadilrehman06 from '../assets/aadilrehman06.png'

import apnidiary from '../assets/apnidiary.png';
import apnidiary01 from '../assets/apnidiary01.png';
import apnidiary02 from '../assets/apnidiary02.png';
import apnidiary03 from '../assets/apnidiary03.png';

import homlary from '../assets/homlary.png';
import homlary01 from '../assets/homlary01.png';
import homlary02 from '../assets/homlary02.png';
import homlary03 from '../assets/homlary03.png';
import homlary04 from '../assets/homlary04.png';
import homlary05 from '../assets/homlary05.png';


import about01 from '../assets/about01.png';
import about02 from '../assets/about02.png';
import about03 from '../assets/about03.png';
import about04 from '../assets/about04.png';

import mongodb from '../assets/mongodb.png';
import express from '../assets/express.png';
import restfullapi from '../assets/restfullapi.png'

import profile from '../assets/profile.png';
import circle from '../assets/circle.svg';
import logo from '../assets/logo.png';

import adidas from '../assets/adidas.png';
import amazon from '../assets/amazon.png';
import asus from '../assets/asus.png';
import bolt from '../assets/bolt.png';
import nb from '../assets/nb.png';
import skype from '../assets/skype.png';
import spotify from '../assets/spotify.png';


export default {
  restfullapi,
  mongodb,
  express,
  email,
  mobile,
  api,
  cpp,
  css,
  figma,
  flutter,
  git,
  graphql,
  html,
  javascript,
  mu5,
  node,
  python,
  react,
  redux,
  sass,
  typescript,
  vue,
  about01,
  about02,
  about03,
  about04,
  profile,
  circle,
  logo,
  adidas,
  amazon,
  asus,
  bolt,
  nb,
  skype,
  spotify,



  portfolio,
  portfolio01,
  portfolio02,
  portfolio03,
  portfolio04,
  portfolio05,
  portfolio06,
  portfolio07,
  portfolio08,

  aadilrehman,
  aadilrehman01,
  aadilrehman02,
  aadilrehman03,
  aadilrehman04,
  aadilrehman05,
  aadilrehman06,

  apnidiary,
  apnidiary01,
  apnidiary02,
  apnidiary03,

  homlary,
  homlary01,
  homlary02,
  homlary03,
  homlary04,
  homlary05,
  
};